import { Link } from "react-router-dom";
import { contactInfo } from "@/mocks/about";

const footerLinks = {
  快速导航: [
    { name: "首页推荐", path: "/" },
    { name: "分类浏览", path: "/category/all" },
    { name: "影视资讯", path: "/category/all" },
    { name: "关于我们", path: "/about" },
  ],
  热门分类: [
    { name: "动作片", path: "/category/action" },
    { name: "科幻片", path: "/category/scifi" },
    { name: "喜剧片", path: "/category/comedy" },
    { name: "动漫", path: "/category/animation" },
  ],
  帮助支持: [
    { name: "常见问题", path: "/about" },
    { name: "联系我们", path: "/about" },
    { name: "用户协议", path: "/" },
    { name: "隐私政策", path: "/" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span
                className="text-lg font-semibold text-background-50"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                91看网页版
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60 mb-5">
              无需下载安装，打开浏览器即可畅享海量高清视频内容。91看网页版是您最佳的在线影视观看选择。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-5">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 91看网页版 版权所有 | {contactInfo.email}
          </p>
          <p className="text-xs text-background-50/40">
            本站内容仅供学习和交流，不存储任何视频文件
          </p>
        </div>
      </div>
    </footer>
  );
}